module.exports = __webpack_public_path__ + "packs/media/images/badges/altro_anno-465b9c49a991edaf5cadb3192a014ac9.png";